import { NetworkService } from "@/services/NetworkService"
import endpoints from "@/infrastructure/http/endpoints"
import { IUserRemoteDataSource } from "../../interfaces/remote/IUserRemoteDataSource"
import { SubscriptionHistoryResponseDTO } from "@/infrastructure/dto/SubscriptionHistoryResponseDTO"
import { ListPrescriptionFeedbackQueryParamsDTO } from "@/domain/dto/ListPrescriptionFeedbackQueryParamsDTO"
import { PrescriptionFeedbackResponseDTO } from "@/infrastructure/dto/PrescriptionFeedbackResponseDTO"
import { ListCancellationReasonsQueryParamsDTO } from "@/domain/dto/ListCancellationReasonsQueryParamsDTO"
import { CancellationReasonListResponseDTO } from "@/infrastructure/dto/CancellationReasonListResponseDTO"

export class UserRemoteDataSource implements IUserRemoteDataSource {
    network
    constructor(ntw: NetworkService) {
        this.network = ntw
    }

    listSubscriptionHistory(userId: string): Promise<SubscriptionHistoryResponseDTO> {
        return this.network.get(`${endpoints.userSubscriptionHistory}/${userId}`)
    }

    listPrescriptionFeedback(params: ListPrescriptionFeedbackQueryParamsDTO): Promise<PrescriptionFeedbackResponseDTO> {
        return this.network.get(endpoints.actionFeedbacks, params)
    }

    listCancellationReasons(params: ListCancellationReasonsQueryParamsDTO): Promise<CancellationReasonListResponseDTO> {
        return this.network.get(endpoints.cancellation_reasons, params)

        //     return Promise.resolve({
        //         status: true,
        //         data: [
        //             {
        //                 subscription_id: "sub_001",
        //                 subscription_type: "ios",
        //                 reason_for_cancellation: "Não utilizo mais o aplicativo",
        //                 user: { id: "u1", name: "Maria Silva", email: "maria.silva@email.com" },
        //                 plan: { id: "p1", title: "Plano Mensal", billing_cycle: "monthly", price: 29.9 },
        //                 status: "canceled",
        //                 ends_at: "2026-06-30T00:00:00Z",
        //                 canceled_at: "2026-06-10T14:23:00Z",
        //                 created_at: "2026-06-10T14:23:00Z",
        //                 updated_at: "2026-06-10T14:23:00Z",
        //             },
        //             {
        //                 subscription_id: "sub_002",
        //                 subscription_type: "android",
        //                 reason_for_cancellation: "Preço muito elevado",
        //                 user: { id: "u2", name: "João Souza", email: "joao.souza@email.com" },
        //                 plan: { id: "p2", title: "Plano Anual", billing_cycle: "yearly", price: 249.9 },
        //                 status: "canceled",
        //                 ends_at: "2026-12-31T00:00:00Z",
        //                 canceled_at: "2026-06-15T09:10:00Z",
        //                 created_at: "2026-06-15T09:10:00Z",
        //                 updated_at: "2026-06-15T09:10:00Z",
        //             },
        //             {
        //                 subscription_id: "sub_003",
        //                 subscription_type: "web",
        //                 reason_for_cancellation: "Encontrei uma alternativa melhor",
        //                 user: { id: "u3", name: "Ana Pereira", email: "ana.pereira@email.com" },
        //                 plan: { id: "p1", title: "Plano Mensal", billing_cycle: "monthly", price: 29.9 },
        //                 status: "canceled",
        //                 ends_at: "2026-06-22T00:00:00Z",
        //                 canceled_at: "2026-06-20T18:45:00Z",
        //                 created_at: "2026-06-20T18:45:00Z",
        //                 updated_at: "2026-06-20T18:45:00Z",
        //             },
        //         ],
        //         prev_page_url: null,
        //         next_page_url: null,
        //         path: "/admin/cancellation-reasons/subscriptions",
        //         per_page: 15,
        //         to: 3,
        //         total: 3,
        //         current_page: 1,
        //     })
    }
}
